const queryPrefix = 'qualifications'

export const QualificationsQueryKeys = {
  Qualification: `${queryPrefix}/qualification`,
  Qualifications: `${queryPrefix}/qualifications`,
  QualificationVersion: `${queryPrefix}/qualification-version`,
  QualificationVersions: `${queryPrefix}/qualification-versions`,
  UserQualifications: `${queryPrefix}/user-qualifications`,
  QualificationsSearch: `${queryPrefix}/qualifications-search`,
  QualificationVersionsSearch: `${queryPrefix}/qualification-versions-search`,
} as const
